import { createSlice } from "@reduxjs/toolkit";

const shopStatus = 1;

const shopStatusSlice = createSlice({
    name: "shopStatus",
    initialState: {
        shopStatus,
    },
    reducers: {
        reSetShopStatus(state,action){
            state.shopStatus = 1
        },
        setShopStatus(state, action) {
            state.shopStatus = action.payload;
        },
    },
});


export const {
    reSetShopStatus,
    setShopStatus
} = shopStatusSlice.actions;

export default shopStatusSlice.reducer;
